Lang = function () {
    var phraseBook = null;
    var staticUrl = '/';
    if (document.body.dataset.staticContentUrl != null) {
        staticUrl = document.body.dataset.staticContentUrl;
    }
    $.getJSON(staticUrl + "js/lang/lang-fr.json", function(json) {
        phraseBook = json;
    });
    return {
        translate: function (phrase) {
            return phraseBook[phrase];
        },
        ready: function () {
            return phraseBook != null;
        }
    };
}();


// WEBPACK FOOTER //
// ./lang/lang-fr.js